$(function () {
    $('#register-agree').click(function () {
        let btn = $('#register-mail-btn');
        if ($(this).prop('checked')) {
            btn.prop('disabled', false);
            btn.removeClass('disabled');
            
        } else {
            btn.prop('disabled', true);
            btn.addClass('disabled');
        }
    });
});

$(document).on('submit', '#register-mail-form', function (e) {
    // イベント中止
    e.preventDefault();
    
    let checked = $('#register-agree').prop('checked');
    if(!checked) {
        alert('同意するにチェックしてください。');
        return;
    }
    
    let $form = $(this);
    $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: $form.serializeArray(),
        dataType: 'json',
    }).done(function (data) {
        window.location.href = data.redirect;
    })
});
